import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIModule } from 'libraries/ui/ui.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { HotelResumeModule } from 'libraries/hotel/components/hotel-resume/hotel-resume.module';
import { HotelsListComponent } from './hotels-list.component';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { IqbhMapModule } from 'libraries/hotel/components/iqbh-map/iqbh-map.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { HotelInformationsModalModule } from 'libraries/hotel/components/hotel-informations-modal/hotel-informations-modal.module';
import { HotelModule } from 'libraries/hotel/components/hotel/hotel.module';
import { ViewService } from 'libraries/hotel/services/view.service';
import { HotelsListService } from 'libraries/hotel/containers/hotels-list/services/hotels-list.service';
import { IqbhMapService } from 'libraries/hotel/containers/hotels-list/services/iqbh-map.service';
import { QuotationService } from 'libraries/hotel/services/quotation/quotation.service';
import { PermissionModule } from "../../../permission/permission.module";
import { HotelResourceModule } from 'libraries/service/resources/hotel/hotelResource.module';

@NgModule({
    imports: [
        IqbhMapModule,
        NotificationModule,
        CommonModule,
        UIModule,
        CardModule,
        LoaderModule,
        HotelResumeModule,
        HotelInformationsModalModule,
        HotelModule,
        PermissionModule,
        HotelResourceModule
    ],
    declarations: [
        HotelsListComponent,
    ],
    exports: [
        HotelsListComponent,
    ],
    providers: [
        ViewService,
        HotelsListService,
        IqbhMapService,
        QuotationService,
    ]
})
export class HotelListModule { }
